const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

export function publicAsset(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://') || (BASE_PATH && path.startsWith(BASE_PATH))) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${BASE_PATH}${normalizedPath}`;
}

export default publicAsset;